import React from 'react';
import '../../App.css';

 function Carrinho() {
  return (
    <div>
       {/* <div class="icons">
            <a href="#" class="fas fa-shopping-cart"></a>

        </div> */}
      <div className='carrinho'>
        <h1>Essa é a página do carrinho</h1>
      </div>
    </div>
  )
}

export default Carrinho;
